import React from "react";
import { useTranslation } from "@me8eon/translation";
import { ACTION_ITEMS } from "../poData";

const ActionsForYou: React.FC<{}> = () => {
    const t = useTranslation();
    const tp = (key: string) => t(`productDashboard.overview.${key}`);

    return (
        <>
            {/* ───────── RIGHT SIDEBAR ───────── */}
            <aside className="po-overview__side">
                {/* SIDEBAR ▸ CARD: "Actions for you" — recommended next steps (items 1–3) */}
                <div className="po-card po-actions">
                    <div className="po-card__head">
                        <h3>{tp("actionsTitle")}</h3>
                        <span className="po-card__meta">
                            {tp("actionsMeta")}
                        </span>
                    </div>
                    <ol className="po-actions__list">
                        {ACTION_ITEMS.map((item, i) => (
                            <li className="po-actions__group" key={item.title}>
                                <div
                                    className="po-actions__item"
                                    onClick={() =>
                                        item.url &&
                                        window.open(
                                            item.url,
                                            "_blank",
                                            "noopener,noreferrer"
                                        )
                                    }
                                    key={"div" + item.title}
                                >
                                    <span className="po-actions__num">
                                        {i + 1}
                                    </span>
                                    <span className="po-actions__body">
                                        <span className="po-actions__title">
                                            {t(item.title)}
                                        </span>
                                        {item.hint && (
                                            <span className="po-actions__hint">
                                                {t(item.hint)}
                                            </span>
                                        )}
                                    </span>
                                    {item.url && (
                                        <span className="po-actions__go">
                                            →
                                        </span>
                                    )}
                                </div>
                                {item.children && (
                                    <ul className="po-actions__sub">
                                        {item.children.map((child, j) => (
                                            <li
                                                className="po-actions__item po-actions__item--sub"
                                                key={child.title}
                                                onClick={() =>
                                                    child.url &&
                                                    window.open(
                                                        child.url,
                                                        "_blank",
                                                        "noopener,noreferrer"
                                                    )
                                                }
                                            >
                                                <span className="po-actions__num po-actions__num--sub">
                                                    {i + 1}.{j + 1}
                                                </span>
                                                <span className="po-actions__body">
                                                    <span className="po-actions__title">
                                                        {t(child.title)}
                                                    </span>
                                                    {child.hint && (
                                                        <span className="po-actions__hint">
                                                            {t(child.hint)}
                                                        </span>
                                                    )}
                                                </span>
                                                {child.url && (
                                                    <span className="po-actions__go">
                                                        →
                                                    </span>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ol>
                </div>
            </aside>
        </>
    );
};

export default ActionsForYou;
